/* BikeParts: collection pages show in-stock products first, across the whole collection.
   1. On a collection with no availability filter chosen, swap the grid for the in-stock list
      (the section marks this with data-bp-avail="boot"). The address bar stays the same.
   2. "View more" always adds 35 products; when the in-stock list runs out it carries on into
      sold-out products (handled in the section's Liquid).
   3. Back button: remembers how many "View more" pages were loaded and where you were, and puts
      you back there when you return from a product. */
(function () {
  if (window.__bpStockFirst) return;
  window.__bpStockFirst = true;

  var BOOT = '#ProductGridContainer > [data-bp-avail="boot"]:not([data-bp-done])';

  function key() { return 'bp_lm:' + location.pathname + location.search; }
  function load() { try { return JSON.parse(sessionStorage.getItem(key())) || { n: 0 }; } catch (e) { return { n: 0 }; } }
  function save(o) { try { sessionStorage.setItem(key(), JSON.stringify(o)); } catch (e) {} }
  function sectionId(el) {
    var s = el && el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function navType() {
    try { var n = performance.getEntriesByType('navigation')[0]; return n ? n.type : ''; } catch (e) { return ''; }
  }

  // 1. swap in the in-stock list
  function boot(marker) {
    marker.setAttribute('data-bp-done', '1');
    var box = document.getElementById('ProductGridContainer');
    var id = sectionId(box);
    var done = function () { document.dispatchEvent(new CustomEvent('bp:stock-ready')); };
    if (!box || !id) { marker.remove(); done(); return; }
    var url = new URL(marker.getAttribute('data-in'), location.origin);
    url.searchParams.set('section_id', id);
    fetch(url.toString())
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var src = parse(html).getElementById('ProductGridContainer');
        if (src && src.querySelector('.product-column')) box.innerHTML = src.innerHTML;
        else marker.remove();
        done();
      })
      .catch(function () { marker.remove(); done(); });
  }

  // 2. "View more": always adds PER products. Shopify's in-stock list can include a few products
  //    that have just sold out (the Liquid leaves those out), so a page can come back short.
  //    We fetch ahead and keep spare products in a buffer so every click adds a full PER.
  var PER = 35;
  var S = { list: null, buf: [], next: null, pag: null, busy: false };
  var BTN = '#ProductGridContainer .bp-lm button[is="load-more-button"]';

  function grid() { var b = document.getElementById('ProductGridContainer'); return b ? b.querySelector('.products-list') : null; }
  function cols(list) { return list.querySelectorAll(':scope > .product-column').length; }
  function sync() {
    var list = grid();
    if (S.list !== list) {
      var b = document.querySelector(BTN);
      S = { list: list, buf: [], next: b ? b.getAttribute('action') : null, pag: null, busy: false };
    }
    return list;
  }
  function withSection(u) {
    var url = new URL(u, location.origin);
    var id = sectionId(document.getElementById('ProductGridContainer'));
    if (id) url.searchParams.set('section_id', id);
    return url.toString();
  }
  // fill the grid until it holds `target` products (or everything has been shown)
  // keepY: stay exactly where the shopper is (stops the browser jumping down to the new button)
  function hold(y) { if (y != null && Math.abs(window.scrollY - y) > 1) window.scrollTo({ top: y, behavior: 'instant' }); }
  function fill(target, cb, keepY) {
    var list = sync();
    if (!list || S.busy) { if (cb) cb(); return; }
    S.busy = true;
    var btn = document.querySelector(BTN);
    if (btn) btn.classList.add('btn--loading');
    var n = cols(list);
    (function step() {
      while (S.buf.length && n < target) {
        var node = S.buf.shift();
        list.appendChild(node);
        if (node.classList.contains('product-column')) n++;
      }
      hold(keepY);
      if (n >= target || !S.next) { done(); return; }
      var u = S.next; S.next = null;
      fetch(withSection(u))
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = parse(html);
          var src = doc.querySelector('.products-list');
          if (src) Array.prototype.forEach.call(src.querySelectorAll(':scope > .f-column'), function (el) { S.buf.push(el); });
          var nb = doc.querySelector('.bp-lm button[is="load-more-button"]');
          S.next = nb ? nb.getAttribute('action') : null;
          var p = doc.querySelector('.pagination');
          if (p) S.pag = p.innerHTML;
          step();
        })
        .catch(done);
    })();
    function done() {
      S.busy = false;
      var box = document.getElementById('ProductGridContainer');
      var pag = box && box.querySelector('.pagination');
      var old = document.querySelector(BTN);
      var tpl = old ? old.cloneNode(true) : null;
      if (pag && S.pag) { pag.innerHTML = S.pag; S.pag = null; }
      var more = S.buf.length > 0 || !!S.next;
      var b = document.querySelector(BTN);
      if (more && !b && tpl && pag) { pag.appendChild(tpl); b = tpl; }
      if (b) {
        b.classList.remove('btn--loading');
        if (more) b.setAttribute('action', S.next || location.href); else b.remove();
      }
      if (!more && pag) { var seo = pag.querySelector('.bp-lm__seo'); if (seo) seo.remove(); }
      recount(list);
      hold(keepY);
      if (keepY != null) requestAnimationFrame(function () { hold(keepY); });
      if (cb) cb();
    }
  }
  // keep "Showing X of Y" in line with what's on screen
  function recount(list) {
    var el = document.querySelector('#ProductGridContainer .bp-lm__count');
    if (!el || !list) return;
    var inN = 0, outN = 0, after = false;
    Array.prototype.forEach.call(list.children, function (k) {
      if (k.classList.contains('bp-so-divider')) { after = true; return; }
      if (!k.classList.contains('product-column')) return;
      if (after) outN++; else inN++;
    });
    var t = el.textContent;
    if (/sold out/.test(t)) el.textContent = t.replace(/([\d,]+)( of [\d,]+ sold out)/, (after ? outN : inN) + '$2');
    else el.textContent = t.replace(/Showing [\d,]+/, 'Showing ' + inN);
  }

  // take over the theme's "View more" on our in-stock pages
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(BTN);
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var list = sync();
      if (!list || S.busy) return;
      var o = load();
      o.n = (o.n || 0) + 1;
      save(o);
      fill(cols(list) + PER, null, window.scrollY);
      return;
    }
    if (t.closest('#ProductGridContainer a[href]')) {
      var o2 = load();
      o2.y = window.scrollY;
      save(o2);
    }
  }, true);
  window.addEventListener('pagehide', function () {
    if (!document.getElementById('ProductGridContainer')) return;
    var o = load();
    o.y = window.scrollY;
    save(o);
  });

  // 3. back button: load the same number of "View more" clicks again, then scroll back
  function restore() {
    var o = load();
    var finish = function () { if (o.y) window.scrollTo(0, o.y); };
    if (!document.querySelector('#ProductGridContainer .bp-lm')) { finish(); return; }
    fill(PER * (1 + (o.n || 0)), finish);
  }
  // first screen: top it up to a full PER too
  function topUp() { if (document.querySelector('#ProductGridContainer .bp-lm')) fill(PER); }

  function init() {
    if (!document.getElementById('ProductGridContainer')) return;
    var back = navType() === 'back_forward';
    if (!back) save({ n: 0 });
    var marker = document.querySelector(BOOT);
    var after = back ? restore : topUp;
    if (back && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (marker) { document.addEventListener('bp:stock-ready', after, { once: true }); boot(marker); }
    else after();
    // filters or sorting re-render the grid: start again with the in-stock list
    new MutationObserver(function () {
      var m = document.querySelector(BOOT);
      if (m) { save({ n: 0 }); document.addEventListener('bp:stock-ready', topUp, { once: true }); boot(m); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // 4. "Back to top" button: small dark circle with an arrow and "TOP".
  //    Appears once you've scrolled down a long collection, then glides back up.
  function backToTop() {
    if (!document.getElementById('ProductGridContainer') || document.querySelector('.bp-top')) return;
    var css = document.createElement('style');
    css.textContent =
      '.bp-top{position:fixed;right:24px;bottom:96px;z-index:40;width:56px;height:56px;padding:0;border:0;border-radius:50%;background:#0b0d12;color:#fff;font:inherit;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;box-shadow:0 10px 28px rgba(11,13,18,.28),inset 0 0 0 1px rgba(255,255,255,.08);opacity:0;transform:translateY(12px) scale(.9);pointer-events:none;transition:opacity .25s ease,transform .25s ease,background .2s}' +
      '.bp-top.is-on{opacity:1;transform:none;pointer-events:auto}' +
      '.bp-top:hover,.bp-top:focus-visible{background:#11a2e4;outline:0}' +
      '.bp-top svg{transition:transform .2s}.bp-top:hover svg{transform:translateY(-2px)}' +
      '.bp-top__t{font-size:10px;font-weight:700;letter-spacing:.14em;line-height:1;margin-left:.14em}' +
      '@media (max-width:749px){.bp-top{right:auto;left:16px;bottom:24px;width:46px;height:46px}.bp-top__t{font-size:9px}}';
    css.textContent += '.bp-lm{overflow-anchor:none}';
    document.head.appendChild(css);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bp-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg><span class="bp-top__t">TOP</span>';
    btn.addEventListener('click', function () {
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    });
    document.body.appendChild(btn);
    // phones: bottom-left (clear of the blue add-to-basket icons), and only shows while you're
    // scrolling back up, then tucks away after 2.5s so it never sits over products
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    var ticking = false, lastY = window.scrollY, hideT = null;
    function check() {
      ticking = false;
      var y = window.scrollY, far = y > window.innerHeight * 1.5;
      if (mq && mq.matches) {
        var up = y < lastY - 2, down = y > lastY + 2;
        if (!far || down) btn.classList.remove('is-on');
        else if (up) {
          btn.classList.add('is-on');
          clearTimeout(hideT);
          hideT = setTimeout(function () { btn.classList.remove('is-on'); }, 2500);
        }
      } else {
        btn.classList.toggle('is-on', far);
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function start() { init(); backToTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
